import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '../utils/pixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = '¡QUIERO EL MÉTODO AHORA!',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    trackEvent('AddToCart', {
      content_name: 'Obediencia Sin Gritos - Ebook',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    window.open('https://hogardespierto.com/485494774499451:1', '_blank');
  }} className={`group relative inline-flex items-center justify-center gap-3 bg-accent-500 hover:bg-accent-600 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 ${className}`} data-id="element-10">
      <span data-id="element-11">{text}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-12" />
    </motion.button>;
}